import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '@app/components/common/PageTitle/PageTitle';
import { PersonForm } from '@app/components/Persons/PersonForm';
import { PersonFormV2 } from '@app/components/Persons/PersonFormV2';

const PersonPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageTitle>{t('Thông tin thành viên')}</PageTitle>
      <PersonFormV2 />
    </>
  );
};

export default PersonPage;
